import styled from 'styled-components'

export const Info = styled.div`
  padding: 20px 20px;
  color: white;
  border-radius: 8px;
`

